import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { SecureLinkType } from '@/types/myVaultTypes';

export type SecureLinkActionType = 'revoke' | 'resend' | 'archive';

export const secureLinkActionApi = (
  id: string,
  action: SecureLinkActionType
): Promise<ApiResponseType<SecureLinkType>> => {
  return authApiService.POST(`/my-vault/links/${id}/${action}/`, {});
};
